import { PropsWithChildren, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import styled, { CSSProperties } from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import {
  FOOTBALL_PLAY_PRO_ONBOARDING_CHOOSE_YOUR_LEVEL,
  FOOTBALL_PLAY_PRO_ONBOARDING_SELECT_COMPETITION,
} from '@sorare/core/src/constants/__generated__/routes';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';
import { Color } from '@sorare/core/src/style/types';

const Root = styled(Vertical).attrs({ center: true, gap: 3 })`
  --background-color: #1510ff;

  min-height: var(--100vh);
  padding: var(--double-unit);

  background: linear-gradient(to bottom, #2c2b70, transparent),
    linear-gradient(319deg, var(--background-color) 16.49%, #00fff7 82.68%);
  background-attachment: fixed;
`;
const ChildrenWrapper = styled(Vertical)`
  width: 100%;
  @media ${tabletAndAbove} {
    margin: 0 auto;
  }
`;
const CtaWrapper = styled.div`
  position: sticky;
  bottom: var(--double-unit);
  width: 100%;
  margin-top: auto;

  @media ${tabletAndAbove} {
    width: min-content;
    margin-top: 0;
  }
`;

type Props = {
  center?: boolean;
  backgroundColor?: Color;
  cta?: ReactNode;
};
export const MarketGuidanceLayout = ({
  center,
  backgroundColor,
  cta,
  children,
}: PropsWithChildren<Props>) => {
  const {
    flags: { useNewMarketGuidanceOnboarding = false },
  } = useFeatureFlags();
  const { isMobileApp } = useIsMobileApp();

  if (isMobileApp) {
    return (
      <Navigate to={FOOTBALL_PLAY_PRO_ONBOARDING_SELECT_COMPETITION} replace />
    );
  }

  if (!useNewMarketGuidanceOnboarding) {
    return <Navigate to={FOOTBALL_PLAY_PRO_ONBOARDING_CHOOSE_YOUR_LEVEL} />;
  }

  return (
    <Root style={{ '--background-color': backgroundColor } as CSSProperties}>
      <ChildrenWrapper center={center}>{children}</ChildrenWrapper>
      <CtaWrapper>{cta}</CtaWrapper>
    </Root>
  );
};
